import { FC, ReactNode, SyntheticEvent } from 'react';
import { Button } from './styles';
import { BasicCircleButtonVariant } from './types';

interface BasicCircleButtonProps {
	onClick?: (event: SyntheticEvent) => void;
	children: ReactNode;
	variant?: BasicCircleButtonVariant;
	withBorder?: boolean;
}

export const BasicCircleButton: FC<BasicCircleButtonProps> = ({
	onClick,
	children,
	variant,
	withBorder,
}) => {
	return (
		<Button onClick={!window.matchMedia("(pointer: coarse)").matches ? onClick : undefined} $variant={variant || 'default'} $redBorder={withBorder}>
			{children}
		</Button>
	);
};
